const t = (u) => u.reduce(
  (l, e) => ({ ...l, [e.slug]: { ...e, value: void 0 } }),
  {}
);
export {
  t as getDefaultFieldValues
};
